/**
 * Cursos de la campaña **Bimbo Fijas** (rapiditas y tostadas).
 *
 * Salen de la transcripción de la capacitación del 4 de setiembre de 2026, dictada por
 * Jackelyn Lomas (marca) y Vanesa Delgado (operaciones). Cada cifra que aparece acá
 * (80% de participación, 47%, 90 y 60 días de vida útil, los promedios por día, el 30%)
 * está en esa transcripción. Lo que no estaba, no se escribió: una impulsadora repite
 * esto delante de un cliente.
 *
 * Por qué vive en su propio archivo y no en `bimbo.ts`: ese otro está GENERADO desde
 * `referencia/demo-original.html` y se sobrescribe entero en cada corrida del generador.
 * Esto es contenido real de campaña y se edita a mano, así que necesita un archivo que
 * nadie pise. Los dos se juntan en `catalogo.ts`.
 *
 * En la fase 1 este archivo se convierte en semilla de la migración de datos, igual que
 * el generado.
 */
import type { Curso } from '../../domain/types';

const CURSO_FJ_RAP: Curso = {
    id: `fj-rap`,
    espacioId: `bimbo`,
    slug: `rapiditas-portafolio-y-discurso`,
    titulo: `Rapiditas: los 5 SKU y su discurso`,
    descripcion: `Quién compra Rapiditas, los cinco SKU uno por uno y las palabras que sí y que no puedes usar en tu discurso.`,
    emoji: `🌯`,
    etiqueta: `DISPONIBLE · CAMPAÑA FIJAS`,
    gradiente1: `#C41E28`,
    gradiente2: `#7A0F16`,
    duracionMin: 10,
    orden: 1,
    estado: `publicado`,
    notaMinima: 60,
    insigniaIco: `🏆`,
    insigniaNombre: `Experta en Rapiditas`,
    lecciones: [
      {
        id: `fj-rap-l1`,
        cursoId: `fj-rap`,
        titulo: `La categoría y quién la compra`,
        orden: 1,
        bloques: [
          {
            id: `fj-rap-l1-b1`,
            leccionId: `fj-rap-l1`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">QUIÉN COMPRA RAPIDITAS</text>
  <g transform="translate(48,72)">
    <rect width="180" height="96" rx="14" fill="#E62530"/>
    <text x="90" y="48" text-anchor="middle" font-family="Georgia" font-size="34" font-weight="bold" fill="#fff">80%</text>
    <text x="90" y="72" text-anchor="middle" font-family="sans-serif" font-size="12" font-weight="bold" fill="#fff" opacity=".9">DEL MERCADO</text>
  </g>
  <g transform="translate(270,72)">
    <rect width="180" height="96" rx="14" fill="#1E3F94"/>
    <text x="90" y="46" text-anchor="middle" font-family="Georgia" font-size="25" font-weight="bold" fill="#fff">2018-2019</text>
    <text x="90" y="72" text-anchor="middle" font-family="sans-serif" font-size="12" font-weight="bold" fill="#fff" opacity=".9">CATEGORÍA PIONERA</text>
  </g>
  <g transform="translate(492,72)">
    <rect width="180" height="96" rx="14" fill="#263576"/>
    <text x="90" y="46" text-anchor="middle" font-family="Georgia" font-size="25" font-weight="bold" fill="#fff">18 a 45</text>
    <text x="90" y="72" text-anchor="middle" font-family="sans-serif" font-size="12" font-weight="bold" fill="#fff" opacity=".9">AÑOS, RUTINA ATAREADA</text>
  </g>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Unión es la competencia. Tú vendes la marca que abrió la categoría.</text>
</svg>`
            }
          },
          {
            id: `fj-rap-l1-b2`,
            leccionId: `fj-rap-l1`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>La campaña con la que sales a tienda se llama <b>Cualquier mano puede</b>, y es de Rapiditas, la marca de tortillas de Bimbo.</p>
<p>No estás ofreciendo algo desconocido. Rapiditas es <b>líder del mercado de tortillas con el 80% de participación</b>, en una <b>categoría pionera</b> que se lanzó entre <b>2018 y 2019</b>. Hoy enfrenta a competidores como <b>Unión</b>.</p>
<div class="destacado"><b>Ojo:</b> si ves a un cliente llevando una tortilla de la competencia, ese es tu cliente. Acércate y habla de Rapiditas en lugar de dejarlo pasar.</div>
<p><b>A quién le estás hablando:</b></p>
<ul>
<li>Jóvenes y adultos de <b>18 a 45 años</b>.</li>
<li>Gente con <b>rutinas atareadas</b>, de estudio o de trabajo.</li>
<li>Buscan preparaciones rápidas y más ligeras.</li>
</ul>
<p>Con esa persona delante no hables de cocina elaborada. Habla de rapidez y practicidad: es lo que vino a buscar.</p>`
            }
          }
        ]
      },
      {
        id: `fj-rap-l2`,
        cursoId: `fj-rap`,
        titulo: `Los cinco SKU, uno por uno`,
        orden: 2,
        bloques: [
          {
            id: `fj-rap-l2-b1`,
            leccionId: `fj-rap-l2`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">LOS CINCO SKU, UNO POR UNO</text>
  <g transform="translate(26,66)">
    <rect width="124" height="112" rx="14" fill="#E62530"/>
    <text x="62" y="30" text-anchor="middle" font-family="sans-serif" font-size="14" font-weight="bold" fill="#fff">CLÁSICAS</text>
    <text x="62" y="58" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">12 unidades</text>
    <text x="62" y="76" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">dulce y salado</text>
    <text x="62" y="94" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">las más vendidas</text>
  </g>
  <g transform="translate(162,66)">
    <rect width="124" height="112" rx="14" fill="#1E7D4F"/>
    <text x="62" y="30" text-anchor="middle" font-family="sans-serif" font-size="14" font-weight="bold" fill="#fff">INTEGRALES</text>
    <text x="62" y="58" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">fibra</text>
    <text x="62" y="76" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">trigo integral</text>
  </g>
  <g transform="translate(298,66)">
    <rect width="124" height="112" rx="14" fill="#1E3F94"/>
    <text x="62" y="30" text-anchor="middle" font-family="sans-serif" font-size="14" font-weight="bold" fill="#fff">LINAZA-CHÍA</text>
    <text x="62" y="58" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">primera vegana</text>
    <text x="62" y="76" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">fibra y omega-3</text>
  </g>
  <g transform="translate(434,66)">
    <rect width="124" height="112" rx="14" fill="#3D55B8"/>
    <text x="62" y="32" text-anchor="middle" font-family="Georgia" font-size="20" font-weight="bold" fill="#fff">Cero Cero</text>
    <text x="62" y="58" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">0% azúcar</text>
    <text x="62" y="76" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">0% grasas añadidas</text>
    <text x="62" y="94" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">ligera, fitness</text>
  </g>
  <g transform="translate(570,66)">
    <rect width="124" height="112" rx="14" fill="#C41E28"/>
    <text x="62" y="30" text-anchor="middle" font-family="sans-serif" font-size="14" font-weight="bold" fill="#fff">WRAPS XL</text>
    <text x="62" y="58" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">6 unidades</text>
    <text x="62" y="76" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">preparaciones</text>
    <text x="62" y="94" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">grandes</text>
  </g>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Elige el SKU que le calza al cliente, no le recites los cinco.</text>
</svg>`
            }
          },
          {
            id: `fj-rap-l2-b2`,
            leccionId: `fj-rap-l2`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Son <b>cinco SKU</b> y cada uno resuelve algo distinto. Apréndelos por lo que le sirve al cliente, no de memoria corrida.</p>
<div class="prod-row">
<div class="prod"><img src="/productos/prod-993739.jpg" loading="lazy" alt=""><small>Rapiditas Clásicas 12 un</small></div>
<div class="prod"><img src="/productos/prod-20020684.jpg" loading="lazy" alt=""><small>Rapiditas Integrales</small></div>
<div class="prod"><img src="/productos/prod-20501958.jpg" loading="lazy" alt=""><small>Rapiditas Linaza-Chía</small></div>
<div class="prod"><img src="/productos/prod-20326660.jpg" loading="lazy" alt=""><small>Rapiditas Cero Cero</small></div>
<div class="prod"><img src="/productos/prod-395665.jpg" loading="lazy" alt=""><small>Rapiditas Wraps XL 6 un</small></div>
</div>
<ul>
<li><b>Clásicas:</b> las más vendidas. Vienen en <b>12 unidades</b> y son versátiles para preparaciones dulces y saladas.</li>
<li><b>Integrales:</b> con <b>fibra</b> y trigo integral.</li>
<li><b>Linaza-chía:</b> la <b>primera tortilla vegana</b> del portafolio, con fibra y omega-3.</li>
<li><b>Cero Cero:</b> <b>0% azúcar</b> y <b>0% grasas añadidas</b>. Es la opción ligera, tipo fitness.</li>
<li><b>Wraps XL:</b> <b>6 unidades</b>, para preparaciones grandes.</li>
</ul>
<div class="destacado"><b>Dato de campo:</b> el wrap XL cambió su empaque de amarillo a rojo por un lineamiento regional de Bimbo. Si una clienta te dice que ya no es el de antes, explícale que lo que cambió es el empaque y que el motivo es ese lineamiento.</div>
<p><b>Si te preguntan en góndola:</b></p>
<ul>
<li>Persona fitness: recomienda la <b>Cero Cero</b> o la <b>linaza-chía</b>.</li>
<li>Vida útil: <b>90 días</b>, salvo linaza-chía que son <b>60 días</b>.</li>
<li>No existen opciones libres de gluten.</li>
<li>Son precocidas: se pueden comer crudas o calentadas en sartén o microondas. Lo ideal es la sartén.</li>
</ul>`
            }
          }
        ]
      },
      {
        id: `fj-rap-l3`,
        cursoId: `fj-rap`,
        titulo: `Las palabras que sí y las que no`,
        orden: 3,
        bloques: [
          {
            id: `fj-rap-l3-b1`,
            leccionId: `fj-rap-l3`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">LO QUE SÍ Y LO QUE NO SE DICE</text>
  <g transform="translate(48,54)">
    <rect width="292" height="134" rx="14" fill="#1E7D4F"/>
    <text x="22" y="28" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff" letter-spacing="1">LAS 5 QUE SÍ</text>
    <circle cx="28" cy="46" r="3" fill="#fff" opacity=".8"/>
    <text x="42" y="50" font-family="sans-serif" font-size="13" fill="#fff">práctico</text>
    <circle cx="28" cy="64" r="3" fill="#fff" opacity=".8"/>
    <text x="42" y="68" font-family="sans-serif" font-size="13" fill="#fff">rico</text>
    <circle cx="28" cy="82" r="3" fill="#fff" opacity=".8"/>
    <text x="42" y="86" font-family="sans-serif" font-size="13" fill="#fff">saludable</text>
    <circle cx="28" cy="100" r="3" fill="#fff" opacity=".8"/>
    <text x="42" y="104" font-family="sans-serif" font-size="13" fill="#fff">ideal para almuerzos o cenas</text>
    <circle cx="28" cy="118" r="3" fill="#fff" opacity=".8"/>
    <text x="42" y="122" font-family="sans-serif" font-size="13" fill="#fff">sin octógonos</text>
  </g>
  <g transform="translate(380,54)">
    <rect width="292" height="134" rx="14" fill="#E62530"/>
    <text x="22" y="28" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff" letter-spacing="1">LAS 2 QUE NO</text>
    <text x="22" y="58" font-family="Georgia" font-size="19" font-weight="bold" fill="#fff">desayuno</text>
    <text x="22" y="84" font-family="Georgia" font-size="19" font-weight="bold" fill="#fff">lonchera</text>
    <text x="22" y="110" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">Si el cliente pregunta primero,</text>
    <text x="22" y="126" font-family="sans-serif" font-size="11" fill="#fff" opacity=".92">sí confirmas: con jamón y queso.</text>
  </g>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Esas dos palabras son territorio del pan de molde.</text>
</svg>`
            }
          },
          {
            id: `fj-rap-l3-b2`,
            leccionId: `fj-rap-l3`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Tu discurso tiene palabras obligatorias y palabras prohibidas. No es un consejo, es un lineamiento de marca.</p>
<p><b>Las cinco que sí van:</b></p>
<ul>
<li>práctico</li>
<li>rico</li>
<li>saludable</li>
<li>ideal para almuerzos o cenas</li>
<li>sin octógonos</li>
</ul>
<p><b>Las dos que no se mencionan:</b> <i>desayuno</i> y <i>lonchera</i>. El motivo es de negocio: esos momentos son territorio del pan de molde y Rapiditas no debe canibalizarlo.</p>
<div class="destacado"><b>Ojo con el matiz:</b> tú nunca lo ofreces para el desayuno. Pero si el cliente pregunta, sí puedes confirmarle que sirve para el desayuno con jamón y queso. La diferencia está en quién lo menciona primero.</div>
<p>Arma tu frase con las palabras de arriba: es práctico, es rico, es saludable, no tiene octógonos y es ideal para tu almuerzo o tu cena.</p>`
            }
          }
        ]
      }
    ],
    preguntas: [
      {
        id: `fj-rap-q1`,
        cursoId: `fj-rap`,
        enunciado: `Un cliente compara Rapiditas con la tortilla de Unión y te pregunta por qué debería llevar la tuya.`,
        explicacion: `Rapiditas es líder con el 80% de participación y la categoría es pionera, lanzada entre 2018 y 2019. Ese es tu argumento real. Hablar mal de la competencia no vende y decir que Unión no está en el mercado es falso.`,
        orden: 1,
        opciones: [
          {
            id: `fj-rap-q1-o1`,
            preguntaId: `fj-rap-q1`,
            texto: `Le cuentas que Rapiditas lidera la categoría con el 80% del mercado y que Bimbo la abrió entre 2018 y 2019`,
            orden: 0,
            esCorrecta: true
          },
          {
            id: `fj-rap-q1-o2`,
            preguntaId: `fj-rap-q1`,
            texto: `Le dices que Unión es de mala calidad`,
            orden: 1
          },
          {
            id: `fj-rap-q1-o3`,
            preguntaId: `fj-rap-q1`,
            texto: `Le dices que Unión ya no se vende en el Perú`,
            orden: 2
          },
          {
            id: `fj-rap-q1-o4`,
            preguntaId: `fj-rap-q1`,
            texto: `Le dices que son iguales, que lleve la que quiera`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-rap-q2`,
        cursoId: `fj-rap`,
        enunciado: `Una chica te dice que está entrenando y cuida mucho lo que come. ¿Qué le recomiendas?`,
        explicacion: `La Cero Cero tiene 0% azúcar y 0% grasas añadidas, y la linaza-chía aporta fibra y omega-3. Esas dos son las recomendadas para personas fitness. Ojo: la linaza-chía es la primera tortilla vegana del portafolio, no la integral.`,
        orden: 2,
        opciones: [
          {
            id: `fj-rap-q2-o1`,
            preguntaId: `fj-rap-q2`,
            texto: `Las clásicas, porque son las más vendidas`,
            orden: 0
          },
          {
            id: `fj-rap-q2-o2`,
            preguntaId: `fj-rap-q2`,
            texto: `Las integrales, porque son la única opción vegana`,
            orden: 1
          },
          {
            id: `fj-rap-q2-o3`,
            preguntaId: `fj-rap-q2`,
            texto: `La Cero Cero o la linaza-chía`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-rap-q2-o4`,
            preguntaId: `fj-rap-q2`,
            texto: `Los wraps XL, porque rinden más`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-rap-q3`,
        cursoId: `fj-rap`,
        enunciado: `Una clienta mira el wrap XL y te dice que antes el empaque era amarillo, que este le parece otro producto.`,
        explicacion: `El cambio de amarillo a rojo responde a un lineamiento regional de Bimbo. Sigue siendo el wrap XL de 6 unidades para preparaciones grandes.`,
        orden: 3,
        opciones: [
          {
            id: `fj-rap-q3-o1`,
            preguntaId: `fj-rap-q3`,
            texto: `Le dices que es un producto nuevo que reemplaza al amarillo`,
            orden: 0
          },
          {
            id: `fj-rap-q3-o2`,
            preguntaId: `fj-rap-q3`,
            texto: `Le explicas que lo que cambió es el empaque, de amarillo a rojo, por un lineamiento regional de Bimbo, y que sigue siendo el wrap XL de 6 unidades para preparaciones grandes`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `fj-rap-q3-o3`,
            preguntaId: `fj-rap-q3`,
            texto: `Le dices que el rojo es la versión integral del wrap`,
            orden: 2
          },
          {
            id: `fj-rap-q3-o4`,
            preguntaId: `fj-rap-q3`,
            texto: `Le dices que cambiaron el empaque porque cambió la receta`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-rap-q4`,
        cursoId: `fj-rap`,
        enunciado: `Estás en el pasillo y se acerca una mamá con dos niños. Quieres cerrar la venta rápido.`,
        explicacion: `El discurso se arma con las cinco palabras obligatorias. Lonchera y desayuno no se mencionan porque son territorio del pan de molde.`,
        orden: 4,
        opciones: [
          {
            id: `fj-rap-q4-o1`,
            preguntaId: `fj-rap-q4`,
            texto: `Le dices que es perfecto para la lonchera de sus hijos`,
            orden: 0
          },
          {
            id: `fj-rap-q4-o2`,
            preguntaId: `fj-rap-q4`,
            texto: `Le dices que le soluciona el desayuno de toda la semana`,
            orden: 1
          },
          {
            id: `fj-rap-q4-o3`,
            preguntaId: `fj-rap-q4`,
            texto: `Le dices que es lo más barato del pasillo`,
            orden: 2
          },
          {
            id: `fj-rap-q4-o4`,
            preguntaId: `fj-rap-q4`,
            texto: `Le dices que es práctico, rico y saludable, ideal para el almuerzo o la cena, y que no tiene octógonos`,
            orden: 3,
            esCorrecta: true
          }
        ]
      },
      {
        id: `fj-rap-q5`,
        cursoId: `fj-rap`,
        enunciado: `Un señor toma el paquete y te pregunta directamente: ¿esto sirve para el desayuno?`,
        explicacion: `La restricción aplica a lo que tú ofreces, no a lo que el cliente pregunta. Si él lo menciona primero, sí puedes confirmar que sirve para el desayuno con jamón y queso. Lo que no debes sumar es la lonchera.`,
        orden: 5,
        opciones: [
          {
            id: `fj-rap-q5-o1`,
            preguntaId: `fj-rap-q5`,
            texto: `Le dices que no, que solo sirve para almuerzo o cena`,
            orden: 0
          },
          {
            id: `fj-rap-q5-o2`,
            preguntaId: `fj-rap-q5`,
            texto: `Cambias de tema porque desayuno es palabra prohibida`,
            orden: 1
          },
          {
            id: `fj-rap-q5-o3`,
            preguntaId: `fj-rap-q5`,
            texto: `Le confirmas que sí, por ejemplo con jamón y queso`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-rap-q5-o4`,
            preguntaId: `fj-rap-q5`,
            texto: `Le dices que sí y le agregas que también es ideal para la lonchera`,
            orden: 3
          }
        ]
      }
    ]
  };

const CURSO_FJ_TOS: Curso = {
    id: `fj-tos`,
    espacioId: `bimbo`,
    slug: `tostadas-bimbo`,
    titulo: `Tostadas Bimbo: crocantes y equilibradas`,
    descripcion: `Tres SKU, 47% de participación y frases listas para el pasillo: todo lo que necesitas para vender tostadas Bimbo.`,
    emoji: `🍘`,
    etiqueta: `DISPONIBLE · CAMPAÑA FIJAS`,
    gradiente1: `#B87412`,
    gradiente2: `#6B3F05`,
    duracionMin: 10,
    orden: 2,
    estado: `publicado`,
    notaMinima: 60,
    insigniaIco: `⭐`,
    insigniaNombre: `Experta en Tostadas`,
    lecciones: [
      {
        id: `fj-tos-l1`,
        cursoId: `fj-tos`,
        titulo: `La categoría y su consumidor`,
        orden: 1,
        bloques: [
          {
            id: `fj-tos-l1-b1`,
            leccionId: `fj-tos-l1`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">LA CATEGORÍA Y SU CONSUMIDOR</text>
  <g transform="translate(58,72)">
    <text x="0" y="0" font-family="sans-serif" font-size="12" font-weight="bold" fill="#C8D2E8">BIMBO EN TOSTADAS</text>
    <rect x="0" y="14" width="250" height="38" rx="14" fill="#263576"/>
    <rect x="0" y="14" width="118" height="38" rx="14" fill="#E62530"/>
    <text x="18" y="41" font-family="Georgia" font-size="20" font-weight="bold" fill="#fff">47%</text>
    <text x="0" y="74" font-family="sans-serif" font-size="12" fill="#C8D2E8">Lidera el mercado</text>
    <text x="0" y="92" font-family="sans-serif" font-size="12" fill="#C8D2E8">con 3 productos</text>
  </g>
  <g transform="translate(372,70)">
    <rect width="292" height="50" rx="14" fill="#1E3F94"/>
    <text x="18" y="31" font-family="sans-serif" font-size="13" font-weight="bold" fill="#C8D2E8" letter-spacing="1">TOSTADAS</text>
    <text x="274" y="32" text-anchor="end" font-family="Georgia" font-size="18" font-weight="bold" fill="#fff">25 a 45 años</text>
    <rect y="60" width="292" height="50" rx="14" fill="#263576"/>
    <text x="18" y="91" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="1">RAPIDITAS</text>
    <text x="274" y="92" text-anchor="end" font-family="Georgia" font-size="18" font-weight="bold" fill="#C8D2E8">18 a 45 años</text>
  </g>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Adultos jóvenes que buscan un snack crocante y equilibrado.</text>
</svg>`
            }
          },
          {
            id: `fj-tos-l1-b2`,
            leccionId: `fj-tos-l1`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Las tostadas son parte de la categoría de soluciones de Bimbo, la misma familia que Rapiditas. Son <b>tres productos</b> y ahí <b>Bimbo lidera el mercado con 47% de participación</b>.</p>
<p>Ese número es tu mejor carta de entrada: no estás ofreciendo una marca más del anaquel, estás ofreciendo la que más se vende.</p>
<p>¿Quién compra tostadas? <b>Adultos jóvenes de 25 a 45 años</b> que buscan un snack crocante y equilibrado. Esa es la persona que tienes que ver venir por el pasillo.</p>
<div class="destacado"><b>Ojo:</b> no es el mismo público que Rapiditas. Rapiditas va de 18 a 45 años, gente con rutinas atareadas. Tostadas arranca a los 25. Si impulsas las dos cosas el mismo día, cambia de chip según a quién tengas al frente.</div>
<p>Así se mueve hoy una tienda promedio en tostadas, para que sepas contra qué estás jugando:</p>
<ul>
<li>Viernes: 7 tostadas</li>
<li>Sábado: 9 tostadas</li>
<li>Domingo: 12 tostadas</li>
<li>Lunes: 9 tostadas</li>
</ul>
<p>La meta es un <b>crecimiento de 30% por tienda</b>. Eso no sale parada en la góndola: muévete por toda la tienda y anda a buscar a los clientes.</p>`
            }
          }
        ]
      },
      {
        id: `fj-tos-l2`,
        cursoId: `fj-tos`,
        titulo: `Los tres SKU y lo que los separa`,
        orden: 2,
        bloques: [
          {
            id: `fj-tos-l2-b1`,
            leccionId: `fj-tos-l2`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">LOS TRES SKU DE TOSTADAS</text>
  <g transform="translate(44,64)">
    <rect width="200" height="118" rx="14" fill="#E62530"/>
    <text x="16" y="30" font-family="sans-serif" font-size="16" font-weight="bold" fill="#fff">CLÁSICAS</text>
    <text x="16" y="54" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Veganas</text>
    <text x="16" y="72" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Sin lactosa</text>
    <text x="16" y="90" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Sin saborizantes ni</text>
    <text x="16" y="106" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">conservantes artif.</text>
  </g>
  <g transform="translate(260,64)">
    <rect width="200" height="118" rx="14" fill="#1E3F94"/>
    <text x="16" y="30" font-family="sans-serif" font-size="16" font-weight="bold" fill="#fff">INTEGRALES</text>
    <text x="16" y="54" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Veganas</text>
    <text x="16" y="72" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Sin lactosa</text>
    <text x="16" y="90" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Sin saborizantes ni</text>
    <text x="16" y="106" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">conservantes artif.</text>
  </g>
  <g transform="translate(476,64)">
    <rect width="200" height="118" rx="14" fill="#1E7D4F"/>
    <text x="16" y="31" font-family="Georgia" font-size="19" font-weight="bold" fill="#fff">Cero Cero</text>
    <text x="16" y="54" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Sin grasas añadidas</text>
    <text x="16" y="72" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Sin azúcares</text>
    <text x="16" y="90" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Con inulina</text>
    <text x="16" y="106" font-family="sans-serif" font-size="12" fill="#fff" opacity=".9">Perfil fitness</text>
  </g>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Clásicas e integrales van juntas. La Cero Cero es el carril fitness.</text>
</svg>`
            }
          },
          {
            id: `fj-tos-l2-b2`,
            leccionId: `fj-tos-l2`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Son tres y se parten en dos grupos. Si tienes claro el corte, no te equivocas al recomendar.</p>
<div class="prod-row">
<div class="prod"><img src="/productos/prod-981287.jpg" loading="lazy" alt=""><small>Tostadas Clásicas 10 un</small></div>
<div class="prod"><img src="/productos/prod-981286.jpg" loading="lazy" alt=""><small>Tostadas Integrales</small></div>
<div class="prod"><img src="/productos/prod-20326485.jpg" loading="lazy" alt=""><small>Tostadas Cero Cero</small></div>
</div>
<p><b>Clásicas e integrales</b> comparten lo mismo:</p>
<ul>
<li>Son veganas</li>
<li>Sin lactosa</li>
<li>Sin saborizantes artificiales</li>
<li>Sin conservantes artificiales</li>
</ul>
<p><b>Tostadas Cero Cero</b> es el otro carril: <b>no tiene grasas añadidas ni azúcares</b> e incluye <i>inulina</i>. Está pensada para el consumidor fitness.</p>
<div class="destacado"><b>Dato de campo:</b> si te dicen que se están cuidando o que entrenan, la respuesta es la Cero Cero. Si te preguntan por algo vegano o sin lactosa, son las integrales y las clásicas. Y si te preguntan qué es la inulina y no estás segura, no inventes: dile que lo consultas y lo averiguas.</div>`
            }
          }
        ]
      },
      {
        id: `fj-tos-l3`,
        cursoId: `fj-tos`,
        titulo: `El discurso en el pasillo`,
        orden: 3,
        bloques: [
          {
            id: `fj-tos-l3-b1`,
            leccionId: `fj-tos-l3`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">EL DISCURSO EN EL PASILLO</text>
  <line x1="200" y1="97" x2="318" y2="122" stroke="#3D55B8" stroke-width="2"/>
  <line x1="200" y1="157" x2="318" y2="142" stroke="#3D55B8" stroke-width="2"/>
  <line x1="520" y1="97" x2="402" y2="122" stroke="#3D55B8" stroke-width="2"/>
  <line x1="520" y1="157" x2="402" y2="142" stroke="#3D55B8" stroke-width="2"/>
  <line x1="360" y1="84" x2="360" y2="92" stroke="#3D55B8" stroke-width="2"/>
  <circle cx="360" cy="131" r="41" fill="#D99114"/>
  <text x="360" y="128" text-anchor="middle" font-family="Georgia" font-size="15" font-weight="bold" fill="#10182B">TOSTADA</text>
  <text x="360" y="146" text-anchor="middle" font-family="sans-serif" font-size="11" font-weight="bold" fill="#10182B">BIMBO</text>
  <rect x="304" y="54" width="112" height="30" rx="14" fill="#263576"/>
  <text x="360" y="74" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">Dips</text>
  <rect x="88" y="82" width="112" height="30" rx="14" fill="#1E3F94"/>
  <text x="144" y="102" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">Palta</text>
  <rect x="88" y="142" width="112" height="30" rx="14" fill="#1E3F94"/>
  <text x="144" y="162" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">Queso</text>
  <rect x="520" y="82" width="112" height="30" rx="14" fill="#1E3F94"/>
  <text x="576" y="102" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">Frutas</text>
  <rect x="520" y="142" width="112" height="30" rx="14" fill="#1E3F94"/>
  <text x="576" y="162" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">Mermelada</text>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Rica y crocante, para cualquier momento del día.</text>
</svg>`
            }
          },
          {
            id: `fj-tos-l3-b2`,
            leccionId: `fj-tos-l3`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Tu frase base, la que abre todo y la que tienes que decir sin pensarla:</p>
<p><i>"Son tostadas ricas y crocantes, para cualquier momento del día."</i></p>
<p>Y de ahí le enganchas la combinación, según quién tengas al frente:</p>
<ul>
<li><i>"Quedan riquísimas con palta."</i></li>
<li><i>"Con queso te salvan cuando quieres algo rápido."</i></li>
<li><i>"Con frutas o con mermelada, para el antojo dulce."</i></li>
<li><i>"Con dips, para cuando llega visita."</i></li>
</ul>
<div class="destacado"><b>Ojo:</b> en esta campaña no hay degustación ni merch. Lo único que vende es lo que tú dices. Por eso practica la frase en voz alta antes de entrar a tienda.</div>
<p>Si ves a alguien llevando una tostada de la competencia, acércate igual y ofrécele Bimbo: ahí es donde ganas clientes nuevos. Cierra con el dato duro, <b>Bimbo lidera la categoría con 47% de participación</b>.</p>
<p>Y mientras recorres la tienda, levanta información de la competencia: precios, espacios adicionales y presencia de marcas como Unión.</p>`
            }
          }
        ]
      }
    ],
    preguntas: [
      {
        id: `fj-tos-q1`,
        cursoId: `fj-tos`,
        enunciado: `Estás impulsando tostadas y Rapiditas el mismo día. Ves acercarse a una clienta y decides ofrecerle tostadas. ¿Con qué público estás tratando?`,
        explicacion: `El consumidor de tostadas son adultos jóvenes de 25 a 45 años que buscan un snack crocante y equilibrado. El rango de 18 a 45 con rutinas atareadas es el de Rapiditas, no el de tostadas.`,
        orden: 1,
        opciones: [
          {
            id: `fj-tos-q1-o1`,
            preguntaId: `fj-tos-q1`,
            texto: `Jóvenes y adultos de 18 a 45 años con rutinas atareadas`,
            orden: 0
          },
          {
            id: `fj-tos-q1-o2`,
            preguntaId: `fj-tos-q1`,
            texto: `Adultos jóvenes de 25 a 45 años que buscan un snack crocante y equilibrado`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `fj-tos-q1-o3`,
            preguntaId: `fj-tos-q1`,
            texto: `Familias que se reúnen a cocinar los fines de semana`,
            orden: 2
          },
          {
            id: `fj-tos-q1-o4`,
            preguntaId: `fj-tos-q1`,
            texto: `Niños en edad escolar`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-tos-q2`,
        cursoId: `fj-tos`,
        enunciado: `Un cliente te dice que está entrenando y que quiere algo ligero. ¿Qué tostada le ofreces?`,
        explicacion: `La Cero Cero es la que está pensada para el consumidor fitness: no tiene grasas añadidas ni azúcares e incluye inulina.`,
        orden: 2,
        opciones: [
          {
            id: `fj-tos-q2-o1`,
            preguntaId: `fj-tos-q2`,
            texto: `Las tostadas integrales, porque son veganas y sin lactosa`,
            orden: 0
          },
          {
            id: `fj-tos-q2-o2`,
            preguntaId: `fj-tos-q2`,
            texto: `Las tostadas clásicas, porque no llevan conservantes artificiales`,
            orden: 1
          },
          {
            id: `fj-tos-q2-o3`,
            preguntaId: `fj-tos-q2`,
            texto: `Las tostadas Cero Cero, que no tienen grasas añadidas ni azúcares e incluyen inulina`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-tos-q2-o4`,
            preguntaId: `fj-tos-q2`,
            texto: `Cualquiera, las tres son iguales en eso`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-tos-q3`,
        cursoId: `fj-tos`,
        enunciado: `Una señora te pregunta si las tostadas integrales sirven para ella, que es vegana y además no toma lactosa. ¿Qué le respondes?`,
        explicacion: `Las tostadas integrales y las clásicas son veganas, sin lactosa y sin saborizantes ni conservantes artificiales. Esa respuesta la puedes dar con total seguridad.`,
        orden: 3,
        opciones: [
          {
            id: `fj-tos-q3-o1`,
            preguntaId: `fj-tos-q3`,
            texto: `Que sí: las integrales y las clásicas son veganas y sin lactosa`,
            orden: 0,
            esCorrecta: true
          },
          {
            id: `fj-tos-q3-o2`,
            preguntaId: `fj-tos-q3`,
            texto: `Que solo la Cero Cero es vegana`,
            orden: 1
          },
          {
            id: `fj-tos-q3-o3`,
            preguntaId: `fj-tos-q3`,
            texto: `Que ninguna de las tres es apta para veganos`,
            orden: 2
          },
          {
            id: `fj-tos-q3-o4`,
            preguntaId: `fj-tos-q3`,
            texto: `Que mejor consulte con un especialista`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-tos-q4`,
        cursoId: `fj-tos`,
        enunciado: `Un señor toma el paquete, lo mira y te dice: "¿y esto con qué se come?". ¿Cuál es la respuesta que te enseñaron?`,
        explicacion: `El discurso de tostadas es exactamente ese: opción rica y crocante para cualquier momento del día, combinada con palta, queso, frutas, mermelada o dips.`,
        orden: 4,
        opciones: [
          {
            id: `fj-tos-q4-o1`,
            preguntaId: `fj-tos-q4`,
            texto: `Que solo se comen solas, como galleta`,
            orden: 0
          },
          {
            id: `fj-tos-q4-o2`,
            preguntaId: `fj-tos-q4`,
            texto: `Que le dices que la lleve y la pruebe, sin explicarle con qué la puede acompañar`,
            orden: 1
          },
          {
            id: `fj-tos-q4-o3`,
            preguntaId: `fj-tos-q4`,
            texto: `Que le explicas primero todos los ingredientes del empaque`,
            orden: 2
          },
          {
            id: `fj-tos-q4-o4`,
            preguntaId: `fj-tos-q4`,
            texto: `Que son ricas y crocantes para cualquier momento del día, y que van con palta, queso, frutas, mermelada o dips`,
            orden: 3,
            esCorrecta: true
          }
        ]
      },
      {
        id: `fj-tos-q5`,
        cursoId: `fj-tos`,
        enunciado: `Es viernes, llevas pocas tostadas vendidas y la góndola está tranquila. Ves a una clienta llevando una tostada de la competencia. ¿Qué haces?`,
        explicacion: `La instrucción es desplazarte por toda la tienda y buscar clientes, no quedarte estática en la góndola. Además, en esta campaña no hay degustación ni merch: lo que vende es tu discurso.`,
        orden: 5,
        opciones: [
          {
            id: `fj-tos-q5-o1`,
            preguntaId: `fj-tos-q5`,
            texto: `Te quedas en la góndola esperando a que alguien se acerque`,
            orden: 0
          },
          {
            id: `fj-tos-q5-o2`,
            preguntaId: `fj-tos-q5`,
            texto: `Te mueves por la tienda, te acercas a ella y le ofreces Bimbo con tu discurso`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `fj-tos-q5-o3`,
            preguntaId: `fj-tos-q5`,
            texto: `Le pides a tu supervisor degustación para atraer gente`,
            orden: 2
          },
          {
            id: `fj-tos-q5-o4`,
            preguntaId: `fj-tos-q5`,
            texto: `Anotas que ese día no había clientes y sigues esperando`,
            orden: 3
          }
        ]
      }
    ]
  };

const CURSO_FJ_DUD: Curso = {
    id: `fj-dud`,
    espacioId: `bimbo`,
    slug: `dudas-del-shopper`,
    titulo: `Dudas del shopper: responde sin dudar`,
    descripcion: `Las preguntas que sí te hacen en góndola, con la respuesta que la marca autorizó: preparación, duración, fitness y Tía Rosa.`,
    emoji: `🙋`,
    etiqueta: `DISPONIBLE · CAMPAÑA FIJAS`,
    gradiente1: `#3D55B8`,
    gradiente2: `#1E3F94`,
    duracionMin: 10,
    orden: 3,
    estado: `publicado`,
    notaMinima: 60,
    insigniaIco: `💬`,
    insigniaNombre: `Respuesta Segura`,
    lecciones: [
      {
        id: `fj-dud-l1`,
        cursoId: `fj-dud`,
        titulo: `Rapiditas: cómo se preparan y cuánto duran`,
        orden: 1,
        bloques: [
          {
            id: `fj-dud-l1-b1`,
            leccionId: `fj-dud-l1`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg"><rect width="720" height="240" fill="#10182B"/><circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/><circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/><text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">RAPIDITAS: PRECOCIDAS, CRUDAS O CALENTADAS</text><rect x="48" y="58" width="196" height="88" rx="14" fill="#263576"/><text x="146" y="100" text-anchor="middle" font-family="sans-serif" font-size="20" font-weight="bold" fill="#fff">CRUDA</text><text x="146" y="126" text-anchor="middle" font-family="sans-serif" font-size="13" fill="#C8D2E8">si se puede</text><rect x="262" y="58" width="196" height="88" rx="14" fill="#E62530"/><text x="360" y="100" text-anchor="middle" font-family="sans-serif" font-size="20" font-weight="bold" fill="#fff">SARTÉN</text><text x="360" y="126" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">la opción ideal</text><rect x="476" y="58" width="196" height="88" rx="14" fill="#263576"/><text x="574" y="100" text-anchor="middle" font-family="sans-serif" font-size="19" font-weight="bold" fill="#fff">MICROONDAS</text><text x="574" y="126" text-anchor="middle" font-family="sans-serif" font-size="13" fill="#C8D2E8">también sirve</text><rect x="48" y="152" width="624" height="34" rx="14" fill="#1E3F94"/><rect x="359" y="158" width="2" height="22" fill="#3D55B8"/><text x="204" y="174" text-anchor="middle" font-family="sans-serif" font-size="14" font-weight="bold" fill="#fff">90 días de vida útil</text><text x="516" y="174" text-anchor="middle" font-family="sans-serif" font-size="14" font-weight="bold" fill="#D99114">Linaza y chía: 60 días</text><text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Si te preguntan cómo calentarlas, la sartén es la respuesta.</text></svg>`
            }
          },
          {
            id: `fj-dud-l1-b2`,
            leccionId: `fj-dud-l1`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Estas son tres dudas que te van a soltar en góndola. Respóndelas rápido y sin titubear.</p><p><b>"¿Hay que cocinarlas?"</b> Las tortillas son precocidas. Se pueden consumir crudas o calentadas en sartén o microondas.</p><div class="destacado"><b>Dato de campo:</b> la sartén es la opción ideal. Si el cliente te pregunta cuál es la mejor forma, esa es tu respuesta, no el microondas.</div><p><b>"¿Cuánto me dura?"</b></p><ul><li>Vida útil general: <b>90 días</b>.</li><li>Rapiditas Linaza-Chía: <b>60 días</b>. Es la única que dura menos.</li></ul><p><b>"¿Tienen sin gluten?"</b> No existen opciones libres de gluten. Dilo derecho, sin inventar y sin buscarle la vuelta.</p><div class="destacado"><b>Ojo:</b> vegana no es sin gluten, e integral tampoco. Si le prometes algo que el producto no tiene, le haces daño al cliente y te quema a ti.</div><div class="prod-row"><div class="prod"><img src="/productos/prod-993739.jpg" loading="lazy" alt=""><small>Rapiditas Clásicas 12 un</small></div><div class="prod"><img src="/productos/prod-20501958.jpg" loading="lazy" alt=""><small>Rapiditas Linaza-Chía</small></div></div>`
            }
          }
        ]
      },
      {
        id: `fj-dud-l2`,
        cursoId: `fj-dud`,
        titulo: `Al que quiere cuidarse`,
        orden: 2,
        bloques: [
          {
            id: `fj-dud-l2-b1`,
            leccionId: `fj-dud-l2`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg"><rect width="720" height="240" fill="#10182B"/><circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/><circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/><text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">QUÉ RECOMENDAR A QUIEN SE CUIDA</text><rect x="48" y="56" width="300" height="96" rx="14" fill="#1E3F94"/><text x="198" y="80" text-anchor="middle" font-family="sans-serif" font-size="12" font-weight="bold" fill="#C8D2E8" letter-spacing="2">EN TORTILLAS</text><text x="198" y="108" text-anchor="middle" font-family="sans-serif" font-size="19" font-weight="bold" fill="#fff">Rapidita Cero Cero</text><text x="198" y="132" text-anchor="middle" font-family="sans-serif" font-size="16" fill="#fff">o Linaza y chía</text><rect x="372" y="56" width="300" height="96" rx="14" fill="#1E7D4F"/><text x="522" y="80" text-anchor="middle" font-family="sans-serif" font-size="12" font-weight="bold" fill="#C8D2E8" letter-spacing="2">EN TOSTADAS</text><text x="522" y="108" text-anchor="middle" font-family="sans-serif" font-size="19" font-weight="bold" fill="#fff">Tostada Cero Cero</text><text x="522" y="132" text-anchor="middle" font-family="sans-serif" font-size="16" fill="#fff">con inulina</text><rect x="258" y="162" width="204" height="28" rx="14" fill="#D99114"/><text x="360" y="181" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#10182B" letter-spacing="2">SIN OCTÓGONOS</text><text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Palabra clave del discurso de Rapiditas. Úsala sin miedo.</text></svg>`
            }
          },
          {
            id: `fj-dud-l2-b2`,
            leccionId: `fj-dud-l2`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Cuando alguien te dice que está entrenando, que se está cuidando o que busca algo ligero, la marca ya decidió qué le recomiendas. No improvises.</p><p><b>En tortillas:</b> la Rapidita Cero Cero o la Linaza-Chía.</p><ul><li><b>Rapiditas Cero Cero:</b> 0% azúcar y 0% grasas añadidas. Es la opción ligera, la fitness del portafolio.</li><li><b>Rapiditas Linaza-Chía:</b> la primera tortilla vegana del portafolio, con fibra y omega-3.</li></ul><p><b>En tostadas:</b> las Cero Cero. No tienen grasas añadidas ni azúcares e incluyen inulina, pensadas justo para el consumidor fitness.</p><div class="destacado"><b>Ojo:</b> en el discurso de Rapiditas las palabras clave obligatorias son práctico, rico, saludable, ideal para almuerzos o cenas y <b>sin octógonos</b>. Esa última te salva casi cualquier duda de "¿esto es sano?".</div><p>Y si te preguntan por las otras tostadas: las <i>integrales</i> y las <i>clásicas</i> son veganas, sin lactosa, sin saborizantes ni conservantes artificiales.</p><div class="prod-row"><div class="prod"><img src="/productos/prod-981287.jpg" loading="lazy" alt=""><small>Tostadas Clásicas 10 un</small></div><div class="prod"><img src="/productos/prod-20326485.jpg" loading="lazy" alt=""><small>Tostadas Cero Cero con inulina</small></div><div class="prod"><img src="/productos/prod-20326660.jpg" loading="lazy" alt=""><small>Rapiditas Cero Cero</small></div></div>`
            }
          }
        ]
      },
      {
        id: `fj-dud-l3`,
        cursoId: `fj-dud`,
        titulo: `Rapiditas o Tía Rosa`,
        orden: 3,
        bloques: [
          {
            id: `fj-dud-l3-b1`,
            leccionId: `fj-dud-l3`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg"><rect width="720" height="240" fill="#10182B"/><circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/><circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/><text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">LAS DOS SON DE BIMBO</text><rect x="48" y="56" width="300" height="128" rx="14" fill="#C41E28"/><text x="72" y="88" font-family="sans-serif" font-size="18" font-weight="bold" fill="#fff">RAPIDITAS</text><rect x="72" y="96" width="44" height="4" fill="#fff" opacity=".55"/><text x="72" y="122" font-family="sans-serif" font-size="13" fill="#fff">Practicidad y rapidez</text><text x="72" y="140" font-family="sans-serif" font-size="13" fill="#fff">Rutinas ajetreadas de</text><text x="72" y="158" font-family="sans-serif" font-size="13" fill="#fff">estudio o trabajo</text><text x="72" y="176" font-family="sans-serif" font-size="13" fill="#fff">Preparaciones más ligeras</text><rect x="372" y="56" width="300" height="128" rx="14" fill="#1E3F94"/><text x="396" y="88" font-family="sans-serif" font-size="18" font-weight="bold" fill="#fff">TÍA ROSA</text><rect x="396" y="96" width="44" height="4" fill="#D99114"/><text x="396" y="122" font-family="sans-serif" font-size="13" fill="#fff">Cocina mexicana</text><text x="396" y="140" font-family="sans-serif" font-size="13" fill="#fff">Reuniones familiares</text><text x="396" y="158" font-family="sans-serif" font-size="13" fill="#fff">Recetas más pesadas</text><text x="396" y="176" font-family="sans-serif" font-size="13" fill="#fff">con carnes y nachos</text><text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Nunca hables mal de ninguna: cada una tiene su ocasión.</text></svg>`
            }
          },
          {
            id: `fj-dud-l3-b2`,
            leccionId: `fj-dud-l3`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Te va a pasar: el cliente tiene una Tía Rosa en la mano y te pregunta cuál es mejor. Ojo, <b>Tía Rosa también es de Bimbo</b>. Nunca hables mal de ninguna.</p><p><b>Tía Rosa</b> se enfoca en la cocina mexicana: reuniones familiares y recetas más pesadas, con carnes y nachos.</p><p><b>Rapiditas</b> prioriza la practicidad y la rapidez, para rutinas ajetreadas de estudio o trabajo y preparaciones más ligeras.</p><div class="destacado"><b>Dato de campo:</b> no compares para ganar, compara para ubicar. "Si es para una reunión con carnes y nachos, la Tía Rosa le va. Si es para el día a día, algo rápido y más ligero, la Rapidita." El cliente decide y tú quedas bien parada.</div><p>Te ayuda saber a quién le hablas: el público de Rapiditas son jóvenes y adultos de 18 a 45 años con rutinas atareadas. Y dentro de Rapiditas, las <i>clásicas</i> son las más vendidas, vienen en 12 unidades y sirven para preparaciones dulces y saladas; los <i>wraps XL</i> vienen en 6 unidades para preparaciones grandes.</p><div class="prod-row"><div class="prod"><img src="/productos/prod-993739.jpg" loading="lazy" alt=""><small>Rapiditas Clásicas 12 un</small></div><div class="prod"><img src="/productos/prod-395665.jpg" loading="lazy" alt=""><small>Rapiditas Wraps XL 6 un</small></div></div>`
            }
          }
        ]
      }
    ],
    preguntas: [
      {
        id: `fj-dud-q1`,
        cursoId: `fj-dud`,
        enunciado: `Un señor te dice: "soy celíaco, ¿estas tortillas son libres de gluten?". ¿Qué le respondes?`,
        explicacion: `En el portafolio no existen opciones libres de gluten. Decirlo derecho protege al cliente: ni vegana ni integral significan sin gluten.`,
        orden: 1,
        opciones: [
          {
            id: `fj-dud-q1-o1`,
            preguntaId: `fj-dud-q1`,
            texto: `"Las integrales sí, porque son de trigo integral."`,
            orden: 0
          },
          {
            id: `fj-dud-q1-o2`,
            preguntaId: `fj-dud-q1`,
            texto: `"No tenemos opciones libres de gluten", y se lo dices directo, sin ofrecerle ninguna como apta.`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `fj-dud-q1-o3`,
            preguntaId: `fj-dud-q1`,
            texto: `"La Linaza-Chía sí, porque es vegana."`,
            orden: 2
          },
          {
            id: `fj-dud-q1-o4`,
            preguntaId: `fj-dud-q1`,
            texto: `"No estoy segura, pero pruébela igual, es bien suave."`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-dud-q2`,
        cursoId: `fj-dud`,
        enunciado: `Una señora te dice: "no quiero prender la cocina, ¿estas se comen así nomás?".`,
        explicacion: `Las tortillas son precocidas, así que se pueden consumir crudas o calentadas en sartén o microondas. Si te preguntan cuál es mejor, la sartén es la opción ideal.`,
        orden: 2,
        opciones: [
          {
            id: `fj-dud-q2-o1`,
            preguntaId: `fj-dud-q2`,
            texto: `"No, hay que cocinarlas sí o sí antes de comerlas."`,
            orden: 0
          },
          {
            id: `fj-dud-q2-o2`,
            preguntaId: `fj-dud-q2`,
            texto: `"Solo las clásicas se comen así, las demás no."`,
            orden: 1
          },
          {
            id: `fj-dud-q2-o3`,
            preguntaId: `fj-dud-q2`,
            texto: `"Sí, son precocidas: se pueden comer crudas. Y si quiere calentarlas, en sartén o microondas, siendo la sartén la opción ideal."`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-dud-q2-o4`,
            preguntaId: `fj-dud-q2`,
            texto: `"Depende de cuántos días le queden de vencimiento."`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-dud-q3`,
        cursoId: `fj-dud`,
        enunciado: `Una clienta tiene la Rapidita Linaza-Chía en la mano y te pregunta cuánto le dura.`,
        explicacion: `La vida útil general es de 90 días, con una sola excepción: la Linaza-Chía dura 60 días.`,
        orden: 3,
        opciones: [
          {
            id: `fj-dud-q3-o1`,
            preguntaId: `fj-dud-q3`,
            texto: `"90 días, igual que todas."`,
            orden: 0
          },
          {
            id: `fj-dud-q3-o2`,
            preguntaId: `fj-dud-q3`,
            texto: `"No tiene fecha, porque es precocida."`,
            orden: 1
          },
          {
            id: `fj-dud-q3-o3`,
            preguntaId: `fj-dud-q3`,
            texto: `"30 días nomás, por el omega-3."`,
            orden: 2
          },
          {
            id: `fj-dud-q3-o4`,
            preguntaId: `fj-dud-q3`,
            texto: `"60 días. Es la única que dura menos que las otras, que van a 90 días."`,
            orden: 3,
            esCorrecta: true
          }
        ]
      },
      {
        id: `fj-dud-q4`,
        cursoId: `fj-dud`,
        enunciado: `Un chico que sale del gimnasio te dice: "estoy cuidándome, ¿cuál me conviene?".`,
        explicacion: `La recomendación de la marca para fitness es la Rapidita Cero Cero o la Linaza-Chía, y en tostadas las Cero Cero con inulina.`,
        orden: 4,
        opciones: [
          {
            id: `fj-dud-q4-o1`,
            preguntaId: `fj-dud-q4`,
            texto: `"Las clásicas, que son las más vendidas."`,
            orden: 0
          },
          {
            id: `fj-dud-q4-o2`,
            preguntaId: `fj-dud-q4`,
            texto: `"La Rapidita Cero Cero o la Linaza-Chía. Y si busca tostadas, las Cero Cero, que no tienen grasas añadidas ni azúcares e incluyen inulina."`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `fj-dud-q4-o3`,
            preguntaId: `fj-dud-q4`,
            texto: `"Los wraps XL, así come menos cantidad."`,
            orden: 2
          },
          {
            id: `fj-dud-q4-o4`,
            preguntaId: `fj-dud-q4`,
            texto: `"Las integrales, que son las únicas con fibra."`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-dud-q5`,
        cursoId: `fj-dud`,
        enunciado: `Una señora tiene una Tía Rosa en el carrito y te dice: "¿cuál es mejor, esta o la tuya?".`,
        explicacion: `Tía Rosa también es de Bimbo, así que nunca se habla mal de ninguna: ubicas cada una en su ocasión y dejas que el cliente elija.`,
        orden: 5,
        opciones: [
          {
            id: `fj-dud-q5-o1`,
            preguntaId: `fj-dud-q5`,
            texto: `"Esa es de otra marca y de menor calidad, mejor llévese la mía."`,
            orden: 0
          },
          {
            id: `fj-dud-q5-o2`,
            preguntaId: `fj-dud-q5`,
            texto: `Le sacas la Tía Rosa del carrito y le pones una Rapidita.`,
            orden: 1
          },
          {
            id: `fj-dud-q5-o3`,
            preguntaId: `fj-dud-q5`,
            texto: `"Las dos son de Bimbo: la Tía Rosa va para cocina mexicana y reuniones familiares con carnes y nachos; la Rapidita, para el día a día, rápido y más ligero."`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-dud-q5-o4`,
            preguntaId: `fj-dud-q5`,
            texto: `"Da lo mismo, señora", y la dejas seguir.`,
            orden: 3
          }
        ]
      }
    ]
  };

const CURSO_FJ_TIE: Curso = {
    id: `fj-tie`,
    espacioId: `bimbo`,
    slug: `la-meta-en-tienda`,
    titulo: `La meta en tienda: crecer 30%`,
    descripcion: `Tus días fijos son de viernes a lunes y tu meta es el promedio de la tienda más 30%. Acá está tu número del día.`,
    emoji: `📈`,
    etiqueta: `DISPONIBLE · CAMPAÑA FIJAS`,
    gradiente1: `#146B41`,
    gradiente2: `#06331E`,
    duracionMin: 12,
    orden: 4,
    estado: `publicado`,
    notaMinima: 60,
    insigniaIco: `🎯`,
    insigniaNombre: `Cazadora de Metas`,
    lecciones: [
      {
        id: `fj-tie-l1`,
        cursoId: `fj-tie`,
        titulo: `De dónde sale tu meta`,
        orden: 1,
        bloques: [
          {
            id: `fj-tie-l1-b1`,
            leccionId: `fj-tie-l1`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <g font-family="sans-serif">
    <rect x="60" y="52" width="14" height="14" rx="3" fill="#3D55B8"/>
    <text x="82" y="64" font-size="12" fill="#C8D2E8">Hoy</text>
    <rect x="128" y="52" width="14" height="14" rx="3" fill="#E62530"/>
    <text x="150" y="64" font-size="12" fill="#C8D2E8">+30%</text>
  </g>
  <line x1="64" y1="172" x2="660" y2="172" stroke="#8C97AF" stroke-width="1" opacity=".55"/>
  <g font-family="sans-serif">
    <rect x="110" y="138" width="80" height="34" rx="3" fill="#3D55B8"/>
    <rect x="110" y="128" width="80" height="10" rx="3" fill="#E62530"/>
    <text x="150" y="161" text-anchor="middle" font-size="13" font-weight="bold" fill="#fff">38</text>
    <text x="150" y="120" text-anchor="middle" font-size="16" font-weight="bold" fill="#D99114">49</text>
    <text x="150" y="188" text-anchor="middle" font-size="12" fill="#C8D2E8">VIERNES</text>

    <rect x="250" y="120" width="80" height="52" rx="3" fill="#3D55B8"/>
    <rect x="250" y="104" width="80" height="16" rx="3" fill="#E62530"/>
    <text x="290" y="152" text-anchor="middle" font-size="13" font-weight="bold" fill="#fff">58</text>
    <text x="290" y="96" text-anchor="middle" font-size="16" font-weight="bold" fill="#D99114">75</text>
    <text x="290" y="188" text-anchor="middle" font-size="12" fill="#C8D2E8">SÁBADO</text>

    <rect x="390" y="100" width="80" height="72" rx="3" fill="#3D55B8"/>
    <rect x="390" y="78" width="80" height="22" rx="3" fill="#E62530"/>
    <text x="430" y="142" text-anchor="middle" font-size="13" font-weight="bold" fill="#fff">80</text>
    <text x="430" y="70" text-anchor="middle" font-size="16" font-weight="bold" fill="#D99114">104</text>
    <text x="430" y="188" text-anchor="middle" font-size="12" fill="#C8D2E8">DOMINGO</text>

    <rect x="530" y="124" width="80" height="48" rx="3" fill="#3D55B8"/>
    <rect x="530" y="110" width="80" height="14" rx="3" fill="#E62530"/>
    <text x="570" y="154" text-anchor="middle" font-size="13" font-weight="bold" fill="#fff">53</text>
    <text x="570" y="102" text-anchor="middle" font-size="16" font-weight="bold" fill="#D99114">69</text>
    <text x="570" y="188" text-anchor="middle" font-size="12" fill="#C8D2E8">LUNES</text>
  </g>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">TU META DE TORTILLAS POR TIENDA</text>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Meta de tostadas: 9 el viernes, 12 el sábado, 16 el domingo, 12 el lunes.</text>
</svg>`
            }
          },
          {
            id: `fj-tie-l1-b2`,
            leccionId: `fj-tie-l1`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Tus días fijos de operación son <b>viernes, sábado, domingo y lunes</b>, en canales de conveniencia. Esos cuatro días son tu campaña.</p>
<p>Cada tienda ya tiene un promedio de venta. Tu meta es ese promedio <b>más 30%</b>. Ni más, ni menos.</p>
<div class="destacado"><b>Ojo:</b> el 30% se mide <b>por tienda</b>, y así lo va a revisar operaciones, tienda por tienda.</div>
<p>Saca tu número antes de entrar a piso:</p>
<ul>
<li><b>Viernes:</b> hoy se venden 38 tortillas y 7 tostadas. Tu meta es <b>49 y 9</b>, o sea 11 tortillas y 2 tostadas más.</li>
<li><b>Sábado:</b> 58 tortillas y 9 tostadas. Tu meta es <b>75 y 12</b>, o sea 17 y 3 más.</li>
<li><b>Domingo:</b> 80 tortillas y 12 tostadas. Tu meta es <b>104 y 16</b>, o sea 24 y 4 más.</li>
<li><b>Lunes:</b> 53 tortillas y 9 tostadas. Tu meta es <b>69 y 12</b>, o sea 16 y 3 más.</li>
</ul>
<p>El domingo es el día más fuerte y también el más exigente: 24 tortillas extra no salen solas si te quedas parada.</p>
<div class="prod-row">
<div class="prod"><img src="/productos/prod-993739.jpg" loading="lazy" alt=""><small>Rapiditas Clásicas 12 un</small></div>
<div class="prod"><img src="/productos/prod-981287.jpg" loading="lazy" alt=""><small>Tostadas Clásicas 10 un</small></div>
</div>`
            }
          }
        ]
      },
      {
        id: `fj-tie-l2`,
        cursoId: `fj-tie`,
        titulo: `Cómo se consigue: sin degustación y sin merch`,
        orden: 2,
        bloques: [
          {
            id: `fj-tie-l2-b1`,
            leccionId: `fj-tie-l2`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <g font-family="sans-serif" transform="translate(58,72)">
    <rect width="280" height="112" rx="14" fill="#C41E28"/>
    <text x="20" y="30" font-size="12" font-weight="bold" fill="#fff" opacity=".85" letter-spacing="2">ESTA VEZ NO TIENES</text>
    <text x="20" y="64" font-size="17" font-weight="bold" fill="#fff">Degustación</text>
    <text x="20" y="92" font-size="17" font-weight="bold" fill="#fff">Material promocional</text>
  </g>
  <text x="360" y="136" text-anchor="middle" font-family="sans-serif" font-size="24" fill="#8C97AF">›</text>
  <g font-family="sans-serif" transform="translate(382,72)">
    <rect width="280" height="112" rx="14" fill="#1E7D4F"/>
    <text x="20" y="30" font-size="12" font-weight="bold" fill="#fff" opacity=".85" letter-spacing="2">LO QUE SÍ TIENES</text>
    <text x="20" y="64" font-size="17" font-weight="bold" fill="#fff">Tu discurso de valor</text>
    <text x="20" y="92" font-size="17" font-weight="bold" fill="#fff">Tus piernas y el carrito</text>
  </g>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">VENTA DIRECTA, PURO DISCURSO</text>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Nadie compra si te quedas parada en la góndola esperando.</text>
</svg>`
            }
          },
          {
            id: `fj-tie-l2-b2`,
            leccionId: `fj-tie-l2`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Esta vez <b>no hay degustación ni material promocional</b>. No tienes merch para regalar. Toda la venta sale de tu discurso de valor y de nada más.</p>
<div class="destacado"><b>Ojo:</b> sin degustación, tu discurso es la única herramienta. Práctico, rico, saludable, ideal para almuerzos o cenas, y sin octógonos.</div>
<p><b>No te quedes parada en la góndola.</b> La instrucción de operaciones es clara: desplázate por toda la tienda y busca clientes. El que te va a comprar muchas veces no pasa por tu pasillo.</p>
<ul>
<li><b>Camina la tienda entera.</b> Tu punto no es un lugar fijo, es toda la sala.</li>
<li><b>Aborda a quien ya tomó la competencia.</b> Si ves a alguien con otra marca en la mano, ahí tienes tu oportunidad de abogar por Bimbo y captar un cliente nuevo.</li>
<li><b>Usa carrito de compras.</b> En tiendas como Tottus está validado que te muevas con carrito.</li>
</ul>
<p>¿Y si se acaba el producto? No va a pasar. <b>No habrá quiebres de stock</b>: las tiendas elegidas tienen stock saturado que tiene que salir para evitar devoluciones.</p>
<p>Eso último léelo dos veces, porque es la razón real de tu meta: si el producto no se mueve, se devuelve.</p>`
            }
          }
        ]
      },
      {
        id: `fj-tie-l3`,
        cursoId: `fj-tie`,
        titulo: `Lo que reportas y cómo te evalúan`,
        orden: 3,
        bloques: [
          {
            id: `fj-tie-l3-b1`,
            leccionId: `fj-tie-l3`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
  <rect width="720" height="240" fill="#10182B"/>
  <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
  <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
  <g font-family="sans-serif" transform="translate(56,70)">
    <g transform="translate(0,0)">
      <circle cx="16" cy="14" r="15" fill="#1E3F94"/>
      <text x="16" y="19" text-anchor="middle" font-size="14" font-weight="bold" fill="#fff">1</text>
      <text x="46" y="10" font-size="15" font-weight="bold" fill="#fff">Espacios adicionales</text>
      <text x="46" y="28" font-size="12" fill="#8C97AF">Exhibiciones de la competencia fuera de góndola</text>
    </g>
    <g transform="translate(0,44)">
      <circle cx="16" cy="14" r="15" fill="#1E3F94"/>
      <text x="16" y="19" text-anchor="middle" font-size="14" font-weight="bold" fill="#fff">2</text>
      <text x="46" y="10" font-size="15" font-weight="bold" fill="#fff">Precios</text>
      <text x="46" y="28" font-size="12" fill="#8C97AF">Cuánto cuesta cada marca en esa tienda</text>
    </g>
    <g transform="translate(0,88)">
      <circle cx="16" cy="14" r="15" fill="#E62530"/>
      <text x="16" y="19" text-anchor="middle" font-size="14" font-weight="bold" fill="#fff">3</text>
      <text x="46" y="10" font-size="15" font-weight="bold" fill="#fff">Marcas presentes</text>
      <text x="46" y="28" font-size="12" fill="#8C97AF">Unión y quién más está en el anaquel</text>
    </g>
  </g>
  <g font-family="sans-serif" transform="translate(514,72)">
    <rect width="152" height="112" rx="14" fill="#D99114"/>
    <text x="76" y="52" text-anchor="middle" font-family="Georgia" font-size="38" font-weight="bold" fill="#fff">30%</text>
    <text x="76" y="76" text-anchor="middle" font-size="12" font-weight="bold" fill="#fff">POR TIENDA</text>
    <text x="76" y="96" text-anchor="middle" font-size="11" fill="#fff" opacity=".9">Evaluación rigurosa</text>
  </g>
  <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">LO QUE TRAES Y CÓMO TE MIDEN</text>
  <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Solo el personal top sigue en campañas fuertes, como la de panetones.</text>
</svg>`
            }
          },
          {
            id: `fj-tie-l3-b2`,
            leccionId: `fj-tie-l3`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Además de vender, traes información. Mientras caminas la tienda, mira qué está haciendo la competencia y levántalo.</p>
<ul>
<li><b>Espacios adicionales:</b> ¿tienen exhibición fuera de su góndola?</li>
<li><b>Precios:</b> a cuánto está cada marca en esa tienda.</li>
<li><b>Marcas presentes:</b> <b>Unión</b> es uno de los competidores que enfrenta Rapiditas. Anota qué está haciendo Unión y qué otras marcas están en el anaquel.</li>
</ul>
<div class="destacado"><b>Ojo:</b> el cumplimiento del crecimiento del 30% se evalúa <b>tienda por tienda</b> y de forma rigurosa. No hay promedio del equipo que te cubra.</div>
<p>Y esto es lo que está en juego: solo se queda el personal <b>top</b> para las campañas fuertes que vienen, como la de <b>panetones</b>. Tu 30% de este fin de semana es tu carta de presentación para la siguiente campaña.</p>
<p>El equipo somos <b>20 impulsadoras</b> entre Lima y provincias, con <b>dos supervisores</b>: diez impulsadoras por supervisor. <b>Yosmark</b> es el coordinador de campaña.</p>`
            }
          }
        ]
      }
    ],
    preguntas: [
      {
        id: `fj-tie-q1`,
        cursoId: `fj-tie`,
        enunciado: `Es domingo y entras a tu tienda. El promedio de esa tienda es 80 tortillas al día. ¿Cuál es tu meta de hoy?`,
        explicacion: `La meta es un crecimiento incremental del 30% sobre el promedio de la tienda: 80 más 24 es 104. Igualar el promedio no es cumplir.`,
        orden: 1,
        opciones: [
          {
            id: `fj-tie-q1-o1`,
            preguntaId: `fj-tie-q1`,
            texto: `88 tortillas`,
            orden: 0
          },
          {
            id: `fj-tie-q1-o2`,
            preguntaId: `fj-tie-q1`,
            texto: `80 tortillas, el promedio de siempre`,
            orden: 1
          },
          {
            id: `fj-tie-q1-o3`,
            preguntaId: `fj-tie-q1`,
            texto: `104 tortillas`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-tie-q1-o4`,
            preguntaId: `fj-tie-q1`,
            texto: `110 tortillas`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-tie-q2`,
        cursoId: `fj-tie`,
        enunciado: `Es sábado, llevas dos horas al lado de la góndola y la gente pasa de largo. ¿Qué haces?`,
        explicacion: `La instrucción es desplazarse activamente por toda la tienda y buscar clientes en lugar de quedarse estática en la góndola. El uso de carritos en tiendas como Tottus está validado.`,
        orden: 2,
        opciones: [
          {
            id: `fj-tie-q2-o1`,
            preguntaId: `fj-tie-q2`,
            texto: `Te desplazas por toda la tienda a buscar clientes, y si estás en Tottus lo haces con carrito de compras`,
            orden: 0,
            esCorrecta: true
          },
          {
            id: `fj-tie-q2-o2`,
            preguntaId: `fj-tie-q2`,
            texto: `Te quedas en la góndola: ese es tu puesto asignado`,
            orden: 1
          },
          {
            id: `fj-tie-q2-o3`,
            preguntaId: `fj-tie-q2`,
            texto: `Esperas a que tu supervisor te autorice a moverte de sitio`,
            orden: 2
          },
          {
            id: `fj-tie-q2-o4`,
            preguntaId: `fj-tie-q2`,
            texto: `Pides material promocional para llamar la atención de la gente`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-tie-q3`,
        cursoId: `fj-tie`,
        enunciado: `Ves a un señor que acaba de poner en su carrito tortillas de otra marca. ¿Qué haces?`,
        explicacion: `La indicación de Trade es estar atenta a los consumidores que eligen marcas de la competencia para abogar por Bimbo y captar clientes nuevos. Y en esta campaña no hay degustación.`,
        orden: 3,
        opciones: [
          {
            id: `fj-tie-q3-o1`,
            preguntaId: `fj-tie-q3`,
            texto: `Lo dejas tranquilo, ya eligió`,
            orden: 0
          },
          {
            id: `fj-tie-q3-o2`,
            preguntaId: `fj-tie-q3`,
            texto: `Le ofreces una degustación para que compare los dos productos`,
            orden: 1
          },
          {
            id: `fj-tie-q3-o3`,
            preguntaId: `fj-tie-q3`,
            texto: `Le comentas que esa marca es de mala calidad`,
            orden: 2
          },
          {
            id: `fj-tie-q3-o4`,
            preguntaId: `fj-tie-q3`,
            texto: `Te acercas a abogar por Bimbo: ese es justo el cliente que hay que captar`,
            orden: 3,
            esCorrecta: true
          }
        ]
      },
      {
        id: `fj-tie-q4`,
        cursoId: `fj-tie`,
        enunciado: `Una compañera te dice que va a ir con calma porque igual el producto se va a quebrar, como la vez pasada. ¿Qué le respondes?`,
        explicacion: `Operaciones confirmó que no habrá quiebres porque las tiendas seleccionadas tienen stock saturado, y ese stock tiene que salir para evitar devoluciones.`,
        orden: 4,
        opciones: [
          {
            id: `fj-tie-q4-o1`,
            preguntaId: `fj-tie-q4`,
            texto: `Que tiene razón, mejor administrar el producto que queda`,
            orden: 0
          },
          {
            id: `fj-tie-q4-o2`,
            preguntaId: `fj-tie-q4`,
            texto: `Que esta vez no habrá quiebres: las tiendas elegidas tienen stock saturado que debe salir para evitar devoluciones`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `fj-tie-q4-o3`,
            preguntaId: `fj-tie-q4`,
            texto: `Que le pida stock extra al supervisor antes de empezar`,
            orden: 2
          },
          {
            id: `fj-tie-q4-o4`,
            preguntaId: `fj-tie-q4`,
            texto: `Que consulte cada mañana con el coordinador de campaña`,
            orden: 3
          }
        ]
      },
      {
        id: `fj-tie-q5`,
        cursoId: `fj-tie`,
        enunciado: `Cierras tu viernes con 44 tortillas vendidas. La tienda promedia 38. ¿Cómo vas contra tu meta?`,
        explicacion: `38 más 30% son 49 tortillas. Superar el promedio no alcanza, porque la meta es el promedio más 30% y se evalúa tienda por tienda.`,
        orden: 5,
        opciones: [
          {
            id: `fj-tie-q5-o1`,
            preguntaId: `fj-tie-q5`,
            texto: `Cumpliste: vendiste más que el promedio de la tienda`,
            orden: 0
          },
          {
            id: `fj-tie-q5-o2`,
            preguntaId: `fj-tie-q5`,
            texto: `No se puede saber hasta que llegue el detalle de cuotas por tienda`,
            orden: 1
          },
          {
            id: `fj-tie-q5-o3`,
            preguntaId: `fj-tie-q5`,
            texto: `Te faltaron 5: tu meta del viernes es 49, no 38`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `fj-tie-q5-o4`,
            preguntaId: `fj-tie-q5`,
            texto: `Cumpliste: el 30% se mide sobre el total del equipo`,
            orden: 3
          }
        ]
      }
    ]
  };

export const CURSOS_FIJAS: Curso[] = [CURSO_FJ_RAP, CURSO_FJ_TOS, CURSO_FJ_DUD, CURSO_FJ_TIE];
